import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()({
  container: {
    padding: '5px',
    height: 'calc(100dvh - 192px)',
  },
  logo: {
    padding: '5px',
  },
})
